import {createSlice} from "@reduxjs/toolkit";
import {setUserInfo} from "../firebase";


const OrderSlice = createSlice({
    name: "ProductSlice",
    initialState: {
        productsToOrder: [],
        ordersCount: 0,
        sum: 0
    },
    reducers: {
        setOrder(state, action) {
            state.productsToOrder.push(action.payload);

        },
        orderCounter(state, action) {
            if (!action.payload) {
                state.ordersCount = state.ordersCount + 1;
            } else {
                state.ordersCount = action.payload;
            }
        },
        deleteOrder(state, action) {
            state.productsToOrder.splice(action.payload, 1);
        },
        calculateSum(state, action) {
            state.sum += action.payload;
        },
        clearOrders(state, action) {
            state.productsToOrder = [];
            state.ordersCount = 0;
            state.sum = 0;
        }
    }
})


export const {setOrder, orderCounter, deleteOrder, calculateSum, clearOrders} = OrderSlice.actions;

export default OrderSlice.reducer;